module.exports = __webpack_public_path__ + "img/book-cover.7e23e636.jpg";